import axios from 'axios';
import _transform from './transform';

const defaultBeforeOptions = {};
const defaultAfterOptions = {};

const request = (apiCall) => (url, payload) => {
    const bop = {};
    const pipeline = {
        execute: (parsedPayload) => apiCall(url, parsedPayload),
        preProcess: (payload) => preProcessStep(payload, defaultBeforeOptions),
        postProcess: (response) => postProcessStep(response, defaultAfterOptions)
    };

    function preProcess(options) {
        pipeline.preProcess = (payload) => preProcessStep(payload, options);
        return bop;
    }

    function postProcess(options) {
        pipeline.postProcess = (response) => postProcessStep(response, options);
        return bop;
    }

    bop.before = preProcess;
    bop.after = postProcess;
    bop.run = (callback) => executePipeline(pipeline)(callback, payload);

    return bop;
};

const isFunction = (obj) => typeof obj === 'function';

const preProcessStep = (payload = {}, options = {}) => {
    const { transformPayload } = options;

    if (transformPayload && isFunction(transformPayload)) {
        return transformPayload(payload);
    }

    return payload;
};

const postProcessStep = (response = {}, options = {}) => {
    let data = getDataFromResponse(response);

    const { transformBody } = options;

    if (transformBody && isFunction(transformBody)) {
        data = transformBody(data);
    }

    if (
        options.statusCode &&
        options.statusCode !== response.status
    ) {
        throw new Error(
            `invalid status code. expected: ${options.statusCode} and received ${response.status}`
        );
    }

    return data;
};

const getDataFromResponse = (response = {}) => response.data;

const executePipeline = (pipeline) => (callback, originalPayload) =>
    new Promise((resolve, reject) => {
        try {
            Promise.resolve()
                .then(() => pipeline.preProcess(originalPayload))
                .then(pipeline.execute)
                .then(pipeline.postProcess)
                .then(callback)
                .then(
                    (result) => resolve(result),
                    (error) => reject(error)
                )
                .catch((error) => {
                    reject(error);
                });
        }
        catch (error) {
            reject(error);
        }
    });

const bop = {
    get: request(axios.get),
    post: request(axios.post),
    put: request(axios.put),
    delete: request(axios.delete),
    transform: _transform
};

export const transform = _transform;

export default bop;
